import { createContext, useContext } from 'react';
import { CompositeViewConfig } from '../../../types';

export interface CompositeViewContextValue {
  selectedSym: string;
  isSynthOI: boolean;
  config: CompositeViewConfig;
  updateConfig: (patch: Partial<CompositeViewConfig>) => void;
}

export const CompositeViewContext =
  createContext<CompositeViewContextValue | null>(null);

export const useCompositeViewCtx = (): CompositeViewContextValue => {
  const ctx = useContext(CompositeViewContext);
  if (ctx == null) {
    throw new Error(
      'useCompositeViewCtx must be used within a CompositeViewProvider',
    );
  }
  return ctx;
};
